import React from 'react';
import { Box } from '@mui/material';

import { DropdownFavoriteOptionIcon } from 'components/pages/ModeReports/DropdownFavoriteOptionIcon/DropdownFavoriteOptionIcon';

export const DropdownSingleSelectCustomTemplate = ({ option, setOptionsAsFavorite, favoriteOptions, children }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className="eui-filter-control-study-pcn">{children ?? option?.name}</div>
      <DropdownFavoriteOptionIcon
        setOptionsAsFavorite={setOptionsAsFavorite}
        option={option}
        favoriteOptions={favoriteOptions}
      />
    </Box>
  );
};
